import classNames from 'classnames';
import { getBackgroundProp, resolveSetting } from '../../../utils/settingsHelper';
import { roundedOptions, shadowOptions } from '../../editor/Toolbar/options';

export const getOptionStyle = (props, settings) => {
	const { borderWidth, borderColor, padding } = props;
	return {
		background: getBackgroundProp(props, settings),
		borderColor: resolveSetting(borderColor, settings),
		borderWidth: `${resolveSetting(borderWidth, settings)}px`,
		paddingTop: padding ? `${resolveSetting(padding[0], settings)}px` : '',
		paddingRight: padding ? `${resolveSetting(padding[1], settings)}px` : '',
		paddingBottom: padding ? `${resolveSetting(padding[2], settings)}px` : '',
		paddingLeft: padding ? `${resolveSetting(padding[3], settings)}px` : '',
	};
};

export const getOptionClasses = (props, settings) => classNames(
	'flex items-center gap-4',
	props.justifyBetween === false ? 'justify-start' : 'justify-between',
	{ [roundedOptions[resolveSetting(props.rounded, settings)]]: !!resolveSetting(props.rounded, settings) },
	shadowOptions[resolveSetting(props.shadow, settings)],
);

export const getCountBadgeStyle = (props, settings) => {
	const { countBackground, countBorderColor, countBorderWidth } = props;
	const resolvedBorderWidth = resolveSetting(countBorderWidth, settings);
	return {
		background: resolveSetting(countBackground, settings) || undefined,
		borderColor: resolveSetting(countBorderColor, settings) || undefined,
		borderWidth: resolvedBorderWidth ? `${resolvedBorderWidth}px` : undefined,
		borderStyle: resolvedBorderWidth ? 'solid' : undefined,
	};
};

export const getCountBadgeClasses = (props, settings) => {
	const hasBadge = resolveSetting(props.countBackground, settings) || resolveSetting(props.countBorderColor, settings);
	const resolvedRounded = resolveSetting(props.countRounded, settings);
	return classNames(
		hasBadge && 'px-2 py-0.5',
		{ [roundedOptions[resolvedRounded]]: !!resolvedRounded },
	);
};

export const getListWrapperClassName = (variant) => {
	switch (variant) {
	case 'card':
		return 'grid grid-cols-1 gap-2 @sm:gap-6 @sm:grid-cols-2 @lg:grid-cols-3 @xl:grid-cols-4';
	case 'list':
	default:
		return 'space-y-2';
	}
};

export function getFieldOptionLabels(value) {
	if (!value) return [];
	if (typeof value === 'string') return [value];
	if (Array.isArray(value)) return value.map((v) => v.label);
	return [value.label];
}

export function formatDisplayFieldValue(value, type, locale = 'en') {
	if (type === 'date') {
		if (!value) return null;
		const date = new Date(value);
		if (Number.isNaN(date.getTime())) return null;
		return new Intl.DateTimeFormat(locale, { dateStyle: 'medium' }).format(date);
	}
	const labels = getFieldOptionLabels(value);
	return labels.length ? labels.join(', ') : null;
}
